import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function DisabilityInsuranceStep(): ReactElement {
  const dispatch = useDispatch();
  const { disabilityInsurancePossessed: disabilityInsurancePossessed } =
    useSelector((state: RootState) => state.steps);

  const formRef = useFormInteractionTracking('have_disability_ins');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Disability Insurance"
          subHeader="Disability insurance pays you a specified percentage of your yearly
          income if you become temporarily or permanently disabled."
        />
      </GrayCard>

      <CardPadding>
        <CardHeader header="Do you have disability insurance?" />
        <Formik
          initialValues={{ disabilityInsurancePossessed }}
          onSubmit={onSubmit}
          validationSchema={createYesNoObjectSchema(
            'disabilityInsurancePossessed'
          )}
        >
          <Form ref={formRef}>
            <YesOrNoStepCreator name="disabilityInsurancePossessed" />
            <NavigationButtons />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { DisabilityInsuranceStep };
